<template>
    <div ref="editorWrapper">
        <ckeditor :editor="editor" :config="editorConfig" v-model="editorData" @ready="onReady" @input="onEditorInput" :disabled="disabled"></ckeditor>
    </div>
</template>

<script>
    import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

    export default {
        name: "Editor",
        props: {
            value: {
                type: [Number, String, Array,Object],
            },
            disabled: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        data() {
            return {
                editorData: null,
                editor: DecoupledEditor,
                editorConfig: {
                    toolbar: {
                        items: [
                            'heading',
                            '|',
                            'htmlEmbed',
                            '|',
                            'fontSize',
                            'fontFamily',
                            '|',
                            'fontColor',
                            'fontBackgroundColor',
                            '|',
                            'bold',
                            'italic',
                            'underline',
                            '|',
                            'alignment',
                            '|',
                            'numberedList',
                            'bulletedList',
                            '|',
                            'outdent',
                            'indent',
                            '|',
                            //'imageUpload',
                            //'uploadImage',
                            'todoList',
                            'link',
                            'blockQuote',
                            'insertTable',
                            'mediaEmbed',
                            '|',
                            'undo',
                            'redo'
                        ]
                    },
                    language: 'vi',
                    //image: {
                    //    toolbar: [
                    //        'imageTextAlternative',
                    //        'imageStyle:full',
                    //        'imageStyle:side'
                    //    ]
                    //},
                    //table: {
                    //    contentToolbar: [
                    //        'tableColumn',
                    //        'tableRow',
                    //        'mergeTableCells',
                    //        'tableCellProperties',
                    //        'tableProperties'
                    //    ]
                    //},
                },
            }
        },
        created() {
        },
        mounted(editor) {
        },
        watch: {
            value: {
                handler(after) {
                    this.editorData = after;
                },
                immediate: true,
            },
        },
        methods: {
            onReady(editor) {
                Array.from(editor.ui.componentFactory.names());
                this.$refs.editorWrapper.prepend(editor.ui.view.toolbar.element);
                //editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                //    return new MyUploadAdapter(loader);
                //};

                //editor.execute('ckfinder');

            },
            onEditorInput(editor) {
                this.$emit('input', editor);
            },
        }
    }
    class MyUploadAdapter {
        constructor(loader) {
            // The file loader instance to use during the upload.
            this.loader = loader;
        }

        // Starts the upload process.
        upload() {
            return this.loader.file
                .then(file => new Promise((resolve, reject) => {
                    this._initRequest();
                    this._initListeners(resolve, reject, file);
                    this._sendRequest(file);
                }));
        }

        // Aborts the upload process.
        abort() {
            if (this.xhr) {
                this.xhr.abort();
            }
        }

        // Initializes the XMLHttpRequest object using the URL passed to the constructor.
        _initRequest() {
            const xhr = this.xhr = new XMLHttpRequest();

            // Note that your request may look different. It is up to you and your editor
            // integration to choose the right communication channel. This example uses
            // a POST request with JSON as a data structure but your configuration
            // could be different.
            xhr.open('POST', `${config.API_END_POINT}master-data/upload`, true);
            xhr.responseType = 'json';
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("_accessToken")).access_token);
        }

        // Initializes XMLHttpRequest listeners.
        _initListeners(resolve, reject, file) {
            const xhr = this.xhr;
            const loader = this.loader;
            const genericErrorText = `Couldn't upload file: ${file.name}.`;

            xhr.addEventListener('error', () => reject(genericErrorText));
            xhr.addEventListener('abort', () => reject());
            xhr.addEventListener('load', () => {
                const response = xhr.response;

                // This example assumes the XHR server's "response" object will come with
                // an "error" which has its own "message" that can be passed to reject()
                // in the upload promise.
                //
                // Your integration may handle upload errors in a different way so make sure
                // it is done properly. The reject() function must be called when the upload fails.
                if (!response || response.error) {
                    return reject(response && response.error ? response.error.message : genericErrorText);
                }

                // If the upload is successful, resolve the upload promise with an object containing
                // at least the "default" URL, pointing to the image on the server.
                // This URL will be used to display the image in the content. Learn more in the
                // UploadAdapter#upload documentation.
                resolve({
                    default: response.url
                });
            });

            // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
            // properties which are used e.g. to display the upload progress bar in the editor
            // user interface.
            if (xhr.upload) {
                xhr.upload.addEventListener('progress', evt => {
                    if (evt.lengthComputable) {
                        loader.uploadTotal = evt.total;
                        loader.uploaded = evt.loaded;
                    }
                });
            }
        }

        // Prepares the data and sends the request.
        _sendRequest(file) {
            // Prepare the form data.
            const data = new FormData();

            data.append('upload', file);

            // Important note: This is the right place to implement security mechanisms
            // like authentication and CSRF protection. For instance, you can use
            // XMLHttpRequest.setRequestHeader() to set the request headers containing
            // the CSRF token generated earlier by your application.

            // Send the request.
            this.xhr.send(data);
        }

    }
</script>
<style>
    .ck-content {
        /*border:1px solid red !important;*/
    }

    .ck-blurred {
        border: 1px solid #d8dbe0 !important;
    }

    .ck-content .image-style-side {
        max-width: 50%;
        float: right;
        margin-left: var(--ck-image-style-spacing);
    }

    .ck-content .image.image_resized {
        max-width: 100%;
    }

    .ck-content .image.image_resized {
        display: block;
        box-sizing: border-box;
    }

        .ck-content .image.image_resized img {
            width: 100%;
        }

        .ck-content .image.image_resized > figcaption {
            display: block;
        }
</style>